import React, { useState, useEffect, useCallback } from 'react';
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import debounce from "lodash.debounce";
import { useHistory } from 'react-router-dom';
import { SearchWrapper } from '../../Admin/DashBoard/dashBoardStyled'
import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../components/Spinner'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { newInvitationsList } from '../../../../../redux/actions/admin';
//table
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'
import { stateConvert } from 'web/components/utils/stateAbbreviation';

function NewInvitations() {
    const dispatch = useDispatch();
    let history = useHistory()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [basicModal, setBasicModal] = useState(false);
    const [basicModalMessage, setBasicModalMessaage] = useState('')
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataList, setDataList] = useState([]);
    const [finalData, setFinalData] = useState([])
    const adminRoles = useSelector(state => state.admin.adminRoles)

    useEffect(() => {
        let userRole = localStorage.getItem('accountType')
        let appUserRolesList = ['Both', 'Buyer', 'Seller']
        if (userRole !== 'Admin') {
            if (appUserRolesList.includes(userRole)) history.push('/dashboard')
            else history.push('/sign-in')
            window.location.reload();
        }
        fetchMyAPI(page, tableSearch);
    }, []);

    const fetchMyAPI = async (pageNumber, search) => {
        let response = '';
        setPage(pageNumber);
        response = await dispatch(newInvitationsList(pageNumber, search));
        if (response.data) {
            setFinalData(response.data?.content)
            setPageCount(response?.data?.totalPages)
        } else {
            if (response.statusCode === 401) {
                localStorage.removeItem('token')
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setBasicModalMessaage(response.message)
                setBasicModal(!basicModal)
            }
        }
    };

    const handleChange = (event, value) => {
        setPage(value);
        fetchMyAPI(value, tableSearch)
    };

    const handleSearchChange = e => {
        let search = e.target.value
        setTableSearch(search)
        handleDebounceSearch(search);
    }
    const handleDebounceSearch = useCallback(debounce((value) => fetchMyAPI(1, value), 500), []);

    const handleToggle = () => {
        setBasicModal(!basicModal);
    }

    // table header
    let headerArr = [
        { title: 'Name', },
        { title: 'Email', },
        { title: 'Company Name', },
        { title: 'Phone No.', },
        { title: 'City', },
        { title: 'State', },
        { title: 'Zip', },
        { title: 'Pallets', },
        { title: 'Locations', },
        { title: 'Annual Basis', },
        { title: 'Comment', },
        { title: 'Invited Date', },
    ];

    return (
        <>
            {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('NEW_INVITATIONS'))) ?
                <TableWrapper>
                    {loaderVisible && <Spinner />}
                    <Heading>
                        <h3>NEW INVITATIONS</h3>
                        <SearchWrapper>
                            <input type="text" placeholder='Search' value={tableSearch}
                                onChange={handleSearchChange} />
                            <AiOutlineSearch />
                        </SearchWrapper>
                    </Heading>

                    <Table responsive>
                        <thead>
                            <tr>
                                {headerArr.map((items, index) => (
                                    <th key={index}>{items.title}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                finalData.map((items, index) => (
                                    <tr key={index}>
                                        <td>{`${items.firstname} ${items.lastname}`}</td>
                                        <td>{items.email}</td>
                                        <td>{items.company}</td>
                                        <td>{items.phone ? items.phone : "NA"}</td>
                                        <td>{items.city ? items.city : "NA"}</td>
                                        <td>{items.state?.length > 0 ? (stateConvert(items.state) || items.state) : 'NA'}</td>
                                        <td>{items.zip ? items.zip : 'NA'}</td>
                                        <td>{items.palletAction ? items.palletAction : "NA"}</td>
                                        <td>{items.numberOfLocations ? items.numberOfLocations : 'NA'}</td>
                                        <td>{items.annualPalletVolume ? items.annualPalletVolume : 'NA'}</td>
                                        <td title={items.comment}>{items.comment?.length > 0 ? (items.comment?.length > 25 ? items.comment.substring(0, 25) + '...' : items.comment) : "NA"}</td>
                                        <td>{items.inviteDate !== null ? moment(items.inviteDate).format("MM/DD/YYYY") : ''}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>

                    {finalData.length !== 0 && <Pagination count={pageCount}
                        page={page}
                        onChange={handleChange} />}

                    <Modal isOpen={basicModal} centered={true}>
                        <ModalBody style={{ textAlign: 'center' }}>
                            {basicModalMessage}
                        </ModalBody>
                        <ModalFooter style={{ justifyContent: 'center' }}>
                            <Button color="primary" onClick={handleToggle}>OK</Button>
                        </ModalFooter>
                    </Modal>
                </TableWrapper>
                :
                <p>You are not authorized to view this page.</p>
            }
        </>
    )

}

export default NewInvitations